import { render, staticRenderFns } from "./InvoiceDetailsSection.vue?vue&type=template&id=bee5baa0&scoped=true&"
import script from "./InvoiceDetailsSection.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee5baa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
